export const productsSliderOptions = (instance, options, maxItems) => {
    let responsiveItemCounts = {
        1360: 5,
        1200: 4,
        1024: 3,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = Math.min(responsiveItemCounts[resolution], Number(maxItems));

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: 1,
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        cssMode: false,
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
            dynamicMainBullets: 10,
            hideOnClick: false,
        },
        breakpoints: breakpoints
    }
}